import http from '../lib/http';

export const API_LOGIN_START = 'API_LOGIN_START';
export const API_LOGIN_ERROR = 'API_LOGIN_ERROR';
export const API_LOGIN_SUCCESS = 'API_LOGIN_SUCCESS';

export const API_LOGIN_PIN_START = 'API_LOGIN_PIN_START';
export const API_LOGIN_PIN_ERROR = 'API_LOGIN_PIN_ERROR';
export const API_LOGIN_PIN_SUCCESS = 'API_LOGIN_PIN_SUCCESS';

export const API_LOGOUT = 'API_LOGOUT';
export const SHOW_LOGIN_BY_PASSWORD = 'SHOW_LOGIN_BY_PASSWORD';

export function showLoginByPassword() {
    return {
        type: SHOW_LOGIN_BY_PASSWORD
    };
}

export function apiPinLogin(fields) {
    return {
        type: 'API_LOGIN_PIN',
        payload: {
            promise: postApiPinLogin(fields)
        }
    };
}

export function apiLogin(fields) {
    return {
        type: 'API_LOGIN',
        payload: {
            promise: postApiLogin(fields)
        }
    };
}

export function logout(deviceId) {
    if (!!deviceId) {
        postLogLogout(deviceId);
    }

    return {
        type: API_LOGOUT,
    };
}

async function postApiPinLogin(fields) {
    const res = await http.post(`/auth/login/pin`, {body: fields});
    if (res.status < 300) return res.json();
    throw res;
}

async function postApiLogin(fields) {
    const res = await http.post(`/auth/login`, {body: fields});
    if (res.status < 300) return res.json();
    throw res;
}

async function postLogLogout(deviceId) {
    const res = await http.post(`/logout/`, {body: deviceId});
    if (res.status < 300) return res.json();
    throw res;
}



// WEBPACK FOOTER //
// ./src/common/login/actions.js